/** Live-chat operations (M29 Phase 2): mirror of backend `app/core/constants/live_chat.py`.
 *  `backend/tests/core/test_live_chat_mirror.py` keeps the two equal (a drift either way fails). */

/** Platform flag, seeded off by migration 0106: off hides every Phase 2 live-chat surface. */
export const LIVE_CHAT_OPS_FLAG = "live_chat_ops" as const;

export const WALLBOARD_VIEW_PERMISSION = "wallboard.view" as const;

export const ROUTING_MANAGE_LIVE_PERMISSION = "routing.manage_live" as const;

export const PRESENCE_STATUS_VALUES = ["online", "away", "busy", "offline"] as const;
export type PresenceStatus = (typeof PRESENCE_STATUS_VALUES)[number];

export const PRESENCE_DEFAULT_STATUS = "offline" as const;

/** Only `online` members receive offers; `busy` keeps the chats they hold. */
export const PRESENCE_ASSIGNABLE = ["online"] as const;

/** Concurrent chats per member (`memberships.chat_limit`) or per team (`teams.chat_limit`, optional). */
export const CHAT_LIMIT_DEFAULT = 3 as const;

export const CHAT_LIMIT_MIN = 1 as const;

export const CHAT_LIMIT_MAX = 20 as const;

export const CHAT_SKILLS_MAX = 20 as const;

export const CHAT_SKILL_PATTERN = "^[a-z0-9_]{1,40}$" as const;

export const CHAT_OFFER_STATUS_VALUES = ["offered", "accepted", "declined", "expired", "cancelled"] as const;
export type ChatOfferStatus = (typeof CHAT_OFFER_STATUS_VALUES)[number];

export const OFFER_TIMEOUT_DEFAULT_S = 30 as const;

export const OFFER_TIMEOUT_MIN_S = 10 as const;

export const OFFER_TIMEOUT_MAX_S = 120 as const;

/** Queue score = tier weight + aging per waiting minute. */
export const QUEUE_AGING_PER_MINUTE_DEFAULT = 1 as const;

export const QUEUE_DEDICATED_HOST_SECONDS_DEFAULT = 60 as const;

export const QUEUE_DEDICATED_HOST_SECONDS_MAX = 600 as const;

export const QUEUE_TIER_WEIGHT_MIN = 0 as const;

export const QUEUE_TIER_WEIGHT_MAX = 1000 as const;

export const WALLBOARD_REFRESH_MAX_S = 5 as const;

export const SEGMENT_KIND_VALUES = ["standard", "suppression"] as const;
export type SegmentKind = (typeof SEGMENT_KIND_VALUES)[number];

export const SEGMENT_NAME_MAX = 80 as const;

export const SCHEDULED_REPORT_VALUES = ["agent_tickets", "agent_chats"] as const;
export type ScheduledReport = (typeof SCHEDULED_REPORT_VALUES)[number];

export const REPORT_CADENCE_VALUES = ["daily", "weekly"] as const;
export type ReportCadence = (typeof REPORT_CADENCE_VALUES)[number];

export const REPORT_SCHEDULE_NAME_MAX = 80 as const;

export const REPORT_RECIPIENTS_MAX = 10 as const;

export const REPORT_WEEKDAY_MIN = 0 as const;

export const REPORT_WEEKDAY_MAX = 6 as const;

export const REPORT_HOUR_MIN = 0 as const;

export const REPORT_HOUR_MAX = 23 as const;

export const REPORT_TIMEZONE_MAX = 64 as const;

export const REPORT_TIMEZONE_DEFAULT = "Asia/Manila" as const;
